/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: AboutUsPage
 * Page name: about-us
 * Page Description: This is the about us page of the website of Ekathva Innovations, it consists of all the
 * details about the company and its business.
*/

import React, { useEffect } from 'react'
import MetaTags from 'react-meta-tags'
import Aos from "aos";
import { Row, Col, Image, Media, Card }from "react-bootstrap"

import Navbar from "components/Navbars/Navbar.js";
import LandingPageAboutus from 'components/Headers/LandingPageAboutus'
import Footer from 'components/Footers/Footer'

import 'assets/style/Style.css'

//Images
import {ReactComponent as Vision} from "assets/images/AboutUs/Vision.svg"
import {ReactComponent as Mission} from "assets/images/AboutUs/Mission.svg"
import {ReactComponent as Linkedin} from "assets/images/AboutUs/Linkedin.svg"

import Vikas from 'assets/images/AboutUs/Vikas.png'
import Akshay from 'assets/images/AboutUs/Akshay.png'
import AkshayKK from 'assets/images/AboutUs/AkshayKK.png'
import Koushik from 'assets/images/AboutUs/Koushik.png'

function AboutUsPage() {

    useEffect( () => {
      window.scrollTo(0, 0)
        Aos.init({ duration: 1000})
    }, [])

    return (
    <div>
        <MetaTags>
            <title>About Us - Who we are | Ekathva Innovations Pvt Ltd</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        </MetaTags>

        <Navbar/>
        <LandingPageAboutus/>
        <br/>

        <div className='homepage_spacing' >
            <h4 data-aos="fade-down-right">
                <span className='aboutus_fontbold'>Ekathva Innovations </span>Private Limited
            </h4>
            <br/>
            <div data-aos="fade-left">
                <p>
                    <strong>
                        In the mid of 2018, as a team of four young minds, we came together to innovate
                        and solve the day to day problems of the common man by our innovative products and
                        services. Resulting in establishing a new venture of our own, <span className='aboutus_fontbold' >"Ekathva Innovations
                        Private Limited"</span>, at JNN College of Engineering, Shivamogga, Karnataka.
                    </strong>
                </p>
                <p>
                    <strong>
                        The company consists of electronics and computer science engineers who have enthusiasm
                        for making day to day life better with their creative ideas. We target to develop
                        User-Friendly and Economic products in the areas like Embedded systems, Printed Circuit
                        Boards, Agriculture Automation, Automotive Electronics, Home and Industrial automation
                        under the horizon of electronics. In the field of information technology, we offer
                        services in Android / iOS App development, Website design, and development. The company
                        also banks on some in-house products and is always a step forward in satisfying customer
                        needs.
                    </strong>
                </p>
                <p>
                    <strong>
                        With the ideas of innovation in creating a better future in the ever-changing field of
                        electronics and IT, the company wants to be a pioneer in some of the products which will
                        change the perspective of everyday life to the layman too.
                    </strong>
                </p>
                <p>
                    <strong>
                        Ekathva Innovations received recognition as a startup under the “<span className='aboutus_fontbold' >Startup India</span>” program of
                        the Government of India and the “<span className='aboutus_fontbold' >Startup Karnataka</span>” program of the Government of Karnataka in 2019.
                    </strong>
                </p>
                <p>
                    <strong>
                        Currently, Ekathva Innovations is being incubated at <span className='aboutus_fontbold' >Deshpande Startups</span>,
                        Hubballi, Karnataka.
                    </strong>
                </p>
            </div>
            <br/>

            <div className='aboutus_mediaspacing'>
                <Media  className='aboutus_borderleft' data-aos='fade-up'>
                    <Vision className="align-self-center mr-3 aboutus_images svgcolor"/>
                    <Media.Body className='aboutus_mediabody'>
                        <Vision className="aboutus_imagedisplay svgcolor"/>
                        <h5 className='aboutus_fontbold' >Our Vision</h5>
                        <p>
                            <strong>
                                To change the perspective of everyday life even to a layman by filling
                                the gap of the need in the field of Electronics and Information Technology
                                with the finest quality solutions.
                            </strong>
                        </p>
                    </Media.Body>
                </Media>
                <br/>

                <Media className='aboutus_borderright' data-aos='fade-right'>
                    <Mission className="align-self-center mr-3 aboutus_images svgcolor" />
                    <Media.Body className='aboutus_mediabody'>
                        <Mission className="aboutus_imagedisplay svgcolor"/>
                        <h5 className='aboutus_fontbold' >Our Mission</h5>
                        <p>
                            <strong>
                                To bring out affordable products with impeccable quality and accuracy in the
                                field of day to day Electronics and Information Technology, for the problems
                                ranging from simpler to complex.
                            </strong>
                        </p>
                    </Media.Body>
                </Media>
            </div>
            <hr/>
        </div>
        <br/>

        <div className='aboutus_mainspace' >
            <h4 data-aos='fade-right'>
                Meet Our <span className='aboutus_fontbold'>Team</span>
            </h4>
            <div>
                <p data-aos='fade-right'><strong className='aboutus_fontsitallic' >Delighted to have passionate and technology-driven people in Team EI</strong></p>
                <br/>
                <Row>
                    <Col data-aos="fade-down-right">
                        <div className='aboutus_cardspace' >
                            <Card className='aboutus_cardsize' >
                                <a className='aboutus_textalign' href="https://www.linkedin.com/in/vikas-hc/" target="_blank">
                                    <div className='aboutus_teamimagespace' >
                                        <Image img src={Vikas} alt="Vikas H C" class="center" className='aboutus_teamimg'/>
                                    </div>
                                    <Card.Body>
                                        <h5 className='aboutus_teamname aboutus_textalign' >Vikas H C</h5>
                                        <p className='aboutus_teamfont aboutus_textalign' ><strong>Co-Founder and CEO</strong><br/><br/>
                                            <Linkedin height={20} width={20} />
                                        </p>
                                </Card.Body>
                                </a>
                            </Card>
                        </div>
                    </Col>

                    <Col data-aos="fade-down">
                        <div className='aboutus_cardspace'>
                            <Card className='aboutus_cardsize' >
                                <a className='aboutus_textalign' href="https://www.linkedin.com/in/akshay-k-kulkarni-aa2764114/" target="_blank">
                                    <div className='aboutus_teamimagespace' >
                                        <Image img src={Akshay} alt=" Akshay K Kulkarni" class="center" className='aboutus_teamimg'/>
                                    </div>
                                    <Card.Body>
                                        <h5 className='aboutus_teamname aboutus_textalign' >Akshay K Kulkarni</h5>
                                        <p className='aboutus_teamfont aboutus_textalign'  ><strong>Co-Founder and COO</strong><br/><br/>
                                            <Linkedin height={20} width={20} />
                                        </p>
                                    </Card.Body>
                                </a>
                            </Card>
                        </div>
                    </Col>

                    <Col data-aos="fade-down-left">
                        <div className='aboutus_cardspace'>
                            <Card className='aboutus_cardsize' >
                                <a className='aboutus_textalign' href="https://www.linkedin.com/in/koushikudupa/" target="_blank">
                                    <div className='aboutus_teamimagespace' >
                                        <Image img src={Koushik} alt="Koushik R Udupa" class="center" className='aboutus_teamimg'/>
                                    </div>
                                    <Card.Body>
                                        <h5 className='aboutus_teamname aboutus_textalign' >Koushik R Udupa</h5>
                                        <p className='aboutus_teamfont aboutus_textalign' ><strong>Co-Founder and CTO</strong><br/><br/>
                                            <Linkedin height={20} width={20} />
                                        </p>
                                    </Card.Body>
                                </a>
                            </Card>
                        </div>
                    </Col>
                    <Col data-aos="fade-up-right">
                        <div className='aboutus_cardspace'>
                            <Card className='aboutus_cardsize' >
                                <a className='aboutus_textalign' href="https://www.linkedin.com/in/akshay-k-k-39135a94" target="_blank">
                                    <div className='aboutus_teamimagespace' >
                                        <Image img src={AkshayKK} alt="AKshay K K" class="center" className='aboutus_teamimg'/>
                                    </div>
                                    <Card.Body>
                                        <h5 className='aboutus_teamname aboutus_textalign' >Akshay K K</h5>
                                        <p className='aboutus_teamfont aboutus_textalign' ><strong>Co-Founder and CFO</strong><br/><br/>
                                            <Linkedin height={20} width={20} />
                                        </p>
                                    </Card.Body>
                                </a>
                            </Card>
                        </div>
                    </Col>

                </Row>

            </div>
        </div>
        <Footer/>
    </div>
    )
}
export default AboutUsPage
